export default __webpack_public_path__ + "static/media/sphere.e758bfca.svg";